/* eslint max-len: 0 */
export const messages = {
  sessiontimeout: {
    id: 'session.Timeout',
    defaultMessage: 'Your session has timed out. Please log in again.',
  },
  lockedout: {
    id: 'login.LockedOut',
    defaultMessage: 'This account has been locked after too many unsuccessful login attempts.  Please wait {parameter1} minutes before trying again.',
  },
  invalidgrant: {
    id: 'login.InvalidGrant',
    defaultMessage: 'Login failed. Please try again.',
  },
  facilitySubscriptionExpired: {
    id: 'login.InvalidGrant.FacilitySubscriptionExpired',
    defaultMessage: 'Login failed. Subscription period has ended. Please contact your administrator.',
  },
  unspecified: {
    id: 'generic.Unspecified',
    defaultMessage: 'An unexpected error has occurred. Please report this to your system administrator.',
  },
  invalidlastnamebirthday: {
    id: 'linkLogin.InvalidGrant.InvalidLastnameBirthday',
    defaultMessage: 'No match found for last name and DOB entered. Please try again.',
  },
  linkexpired: {
    id: 'linkLogin.InvalidGrant.LinkExpired',
    defaultMessage: 'Login failed. The link has expired.',
  },
  invalidOldPassword: {
    id: 'updatePassword.Form.Error.InvalidOldPassword',
    defaultMessage: 'To change your password, you must correctly enter the current password.',
  },
  passwordMustBeDifferent: {
    id: 'updatePassword.Form.Error.MustBeDifferent',
    defaultMessage: 'Password does not meet security requirements.',
  },
  personaldatadownloaded: {
    id: 'dataProtection.Download.Success',
    defaultMessage: 'Your personal data successfully downloaded.',
  },
  personaldatadownloadfailed: {
    id: 'dataProtection.Download.Failure',
    defaultMessage: 'Downloading your personal data failed. Please report this to your system administrator.',
  },
  confirmMismatch: {
    id: 'updatePassword.Form.Error.ConfirmMismatch',
    defaultMessage: 'Passwords do not match.',
  },
  updatePasswordSuccess: {
    id: 'updatePassword.Form.Success',
    defaultMessage: 'Your password has been successfully updated.',
  },
  resetPasswordNotFound: {
    id: 'resetPassword.NotFound',
    defaultMessage: 'The username entered does not match our records.',
  },
  resetPasswordLockedOut: {
    id: 'resetPassword.LockedOut',
    defaultMessage: 'This account has been locked. Please contact your care provider for assistance.',
  },
  resetPasswordNoEmail: {
    id: 'resetPassword.NoEmail',
    defaultMessage: 'This account does not have an associated email address, which is required to reset the password. Please contact your care provider for assistance.',
  },
  resetPasswordEmailNotConfirmed: {
    id: 'resetPassword.EmailNotConfirmed',
    defaultMessage: 'The email address associated with this account has not been confirmed, so the password cannot be reset online. Please contact your care provider for assistance.',
  },
  resetPasswordSuccess: {
    id: 'resetPassword.Success',
    defaultMessage: 'If a valid account exists, an email will be sent to the address on file. If you do not receive an email, please contact your facility.',
  },
  confirmEmailSuccess: {
    id: 'confirmEmail.Success',
    defaultMessage: 'Your email address has been confirmed. Thank you.',
  },
  confirmEmailError: {
    id: 'confirmEmail.Error',
    defaultMessage: 'We cannot confirm your email address.',
  },
  confirmEmailRequired: {
    id: 'confirmEmail.Required',
    defaultMessage: 'We need to confirm your email address.  A confirmation email was sent to {parameter1}.  You can find this email and follow the instructions, or click {parameter2}.',
  },
  confirmationEmailSent: {
    id: 'confirmEmail.Sent',
    defaultMessage: 'A confirmation email was sent to {parameter1}. Follow the instructions to confirm your email address.',
  },
  confirmationEmailSendError: {
    id: 'confirmEmail.SendError',
    defaultMessage: 'We cannot send a confirmation email to your address.',
  },
  securemessagesent: {
    id: 'secureMessage.Sent',
    defaultMessage: 'Message sent successfully.',
  },
  noCcdaConfigured: {
    id: 'healthSummary.NoCcdaConfigured',
    defaultMessage: 'This feature is currently unavailable. Please contact your facility for more information.',
  },
  healthsummarysent: {
    id: 'healthSummary.Sent',
    defaultMessage: 'Health information sent. Contact your care provider to confirm that they have received the document.',
  },
  securemessagesendfailed: {
    id: 'secureMessage.SendFailed',
    defaultMessage: 'Message could not be sent. Try again.',
  },
  healthsummarysendfailed: {
    id: 'healthSummary.SendFailed',
    defaultMessage: 'Health summary could not be sent. Try again.',
  },
  healthsummarysendsecurelyfailed: {
    id: 'healthSummary.SendSecurelyFailed',
    defaultMessage: 'The Health Information Summary could not be sent. Check the direct address or contact your care provider.',
  },
  securemessagenotavailable: {
    id: 'secureMessage.Notavailable',
    defaultMessage: 'The message is not available.',
  },
  securemessagethreadsloadfailed: {
    id: 'messages.Threadsloadfailed',
    defaultMessage: 'Failed to load message threads. Try again.',
  },
  securemessagethreadarchived: {
    id: 'messages.ArchivedSuccess',
    defaultMessage: 'The message has been archived.',
  },
  securemessagethreadunarchived: {
    id: 'messages.UnarchivedSuccess',
    defaultMessage: 'The message has been unarchived.',
  },
  securemessagearchivefailed: {
    id: 'messages.Archivefailed',
    defaultMessage: 'An error has occurred. Please try again.',
  },
  securemessageunreadcountloadfailed: {
    id: 'messages.UnreadCountLoadFailed',
    defaultMessage: '- def - Failed to retrieve the number of unread messages. Please try again.',
  },
  securemessagemarkreviewedfailed: {
    id: 'messages.MarkReviewedFailed',
    defaultMessage: '- def - Failed to mark thread messages as reviewed. Please try again.',
  },
  loadappointmentsfailed: {
    id: 'appointments.Loadfailed',
    defaultMessage: 'Failed to load appointments.',
  },
  noPatientNotifyPreference: {
    id: 'appointments.Filter.NoPatientNotifyPreference',
    defaultMessage: 'Failed to load patient notification preference.',
  },
  questionnairesent: {
    id: 'questionnaire.Sent',
    defaultMessage: 'Questionnaire Successfully Submitted.',
  },
  questionnairesendfailed: {
    id: 'questionnaire.Sendfailed',
    defaultMessage: 'An error has occurred that prevented your questionnaire from being submitted. Please try again.',
  },
  questionnairesdeclinefailed: {
    id: 'questionnaire.DeclineFailed',
    defaultMessage: 'An error has occurred that prevented your questionnaire from being declined. Please try again.',
  },
  questionnairevalidatefailed: {
    id: 'questionnaire.ValidateFailed',
    defaultMessage: 'Please complete all required questions.',
  },
  dismissMessageLink: {
    id: 'link.DismissMessage',
    defaultMessage: 'Dismiss Message?',
  },
  signUpVerifyIdentityFailure: {
    id: 'signup.VerifyIdentity.Failure',
    defaultMessage: 'Signup failed. Please check the information entered.  If this error persists, contact your facility.',
  },
  signUpAccountInformationDuplicateName: {
    id: 'signup.AccountInformationDuplicateName',
    defaultMessage: 'That username is already in use.',
  },
  invitationExpired: {
    id: 'signup.InvitationExpired',
    defaultMessage: 'The PIN provided has expired. Contact the facility to obtain a new one.',
  },
  signupAttempsExceeded: {
    id: 'signup.SignupAttempsExceeded',
    defaultMessage: 'Your PIN has been invalidated after too many failed attempts. Contact the facility to obtain a new PIN.',
  },
  signupSuccess: {
    id: 'signup.SignupSuccess',
    defaultMessage: 'Your account has been created. A welcome email has been sent to { parameter1 } ',
  },
  signupSuccessCantSendEmail: {
    id: 'signup.SignupSuccessCantSendEmail',
    defaultMessage: 'Your account has been created. We cannot send a welcome email at this time. ',
  },
  arSignupSuccess: {
    id: 'signup.AuthRepSignupSuccess',
    defaultMessage: 'Your account has been created. Welcome!',
  },
  signupFailed: {
    id: 'signup.SignupFailed',
    defaultMessage: 'Invalid information',
  },
  patientReminderSettingsSaveSuccess: {
    id: 'patientNotification.Success',
    defaultMessage: 'Notification Settings successfully updated.',
  },
  ccdaNotConfiguredError: {
    id: 'healthSummary.Panel.NotConfiguredError',
    defaultMessage: 'This feature is currently unavailable. Please contact your facility for more information.',
  },
  contactAddedSuccess: {
    id: 'addContact.ContactAddedSuccess',
    defaultMessage: 'The contact has been added.',
  },
  contactEditSuccess: {
    id: 'contact.Edit.Success',
    defaultMessage: 'The contact has been updated.',
  },
  contactInviteSuccess: {
    id: 'contact.Invite.Success',
    defaultMessage: 'The contact has been invited.',
  },
  contactAccessEnabled: {
    id: 'contact.Access.Enabled',
    defaultMessage: 'This contact\'s access to their account has been enabled.',
  },
  contactAccessDisabled: {
    id: 'contact.Access.Disabled',
    defaultMessage: 'This contact\'s access to their account has been disabled.',
  },
  contactEmailRequiredForInvite: {
    id: 'contact.ContactEmailRequiredForInvite',
    defaultMessage: 'A personal contact must have an email address in order to be invited to access your information.',
  },
  failedChangeContactAccess: {
    id: 'contact.Access.FailedChange',
    defaultMessage: 'Failed to change this contact\'s account access.',
  },
  failedSendingEmail: {
    id: 'invitation.Error.Email.Failed',
    defaultMessage: 'An error occurred when attempting to send the invitation email. Please contact your facility for assistance.',
  },
  contactUnlockAccount: {
    id: 'contact.Unlock.Success',
    defaultMessage: 'The contact\'s account has been unlocked.',
  },
  failedContactUnlockAccount: {
    id: 'contact.Unlock.Failure',
    defaultMessage: 'Failed to unlock this contact\'s account.',
  },
  contactPasswordReset: {
    id: 'contact.Password.Reset.Success',
    defaultMessage: 'The contact\'s password has been reset. A temporary password has been sent to {parameter1}.',
  },
  contactPasswordResetFailed: {
    id: 'contact.Password.Reset.Failure',
    defaultMessage: 'An error occurred when trying to email this contact a temporary password. The password has not been reset.',
  },
  contactPasswordResetProgress: {
    id: 'contact.Password.Reset.Progress',
    defaultMessage: 'Working... {parameter1}',
  },
  changeEmailSuccess: {
    id: 'changeEmail.Success',
    defaultMessage: 'Email address successfully updated. A confirmation email has been sent to this address.',
  },
  resetContactPasswordEmailNotConfirmed: {
    id: 'resetPassword.ContactEmailNotConfirmed',
    defaultMessage: 'The email address for this contact has not been confirmed. The email must be confirmed before the password can be reset.',
  },
  emailNotUpdatedMessage: {
    id: 'changeEmail.EmailNotUpdated',
    defaultMessage: 'Email address successfully updated.',
  },
};
